import React from "react";
import AdvisorsVideo from "../AdvisorsVideo/AdvisorsVideo";
import AllAccounts from "../AllAccounts/AllAccounts";
import ContactForm from "../ContactForm/ContactForm";
import CustomerCare from "../CustomerCare/CustomerCare";
import OurStores from "../OurStories/OurStores";

const AllAcountsSection = () => {
  return (
    <>
      {/* <AdvisorsVideo /> */}
      <AllAccounts />
      <ContactForm />
      <CustomerCare />
      {/* <OurStores /> */}
    </>
  );
};

export default AllAcountsSection;
